/* eslint @typescript-eslint/no-explicit-any: 0 */

import React from 'react';

import Tracked from '~/components/Tracked';
import type { MenuItemProps } from '~/legacy/types';
import { logoIcons } from '~/legacy/utils';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import MenuLink from './MenuLink';

const ClothingMenuItem = ({
  link,
  name,
  content,
  pagePosition
}: MenuItemProps) => {
  return (
    <li className="main-header__nav__top-list-item">
      <Tracked.ExternalLink
        variant="none"
        pagePosition="Header"
        name={name as TrackedButtonClickName}
        href={link}
        className="main-header__nav__top-list-item--link flex"
      >
        {name}
      </Tracked.ExternalLink>
      {content?.render ? (
        <div className="main-header__nav__sub-nav-list">
          <div className="main-header__nav__sub-nav-list--offset"></div>
          <div className="main-header__nav__sub-nav-list--container">
            <div className="mx-auto max-w-6xl px-8 pb-12 pt-6">
              <div>
                <div className="flex flex-row gap-6 pb-6">
                  <div className="font-bold">{content?.footwear?.title}</div>
                  {/* Clothing filters */}
                  {content?.footwear?.filters.map(
                    (item: MenuItemProps, i: number) => (
                      <MenuLink
                        key={i}
                        title={item?.title}
                        link={item?.link}
                        pagePosition={pagePosition}
                      />
                    )
                  )}
                </div>

                {content?.footwear?.featuredBrands && (
                  <div className="flex-col">
                    <div className="pb-6 font-bold">Featured brands</div>

                    {/* Clothing featured brands */}
                    <div className="flex grow">
                      <div className=" grid grid-cols-6 content-between gap-x-24 gap-y-6">
                        {content?.footwear?.featuredBrands.children.map(
                          (item: any, i: number) => {
                            const { icon, name, viewAll, path } = item;

                            return (
                              <div key={i} className="size-20">
                                <Tracked.ExternalLink
                                  variant="none"
                                  pagePosition="Header"
                                  name={name as TrackedButtonClickName}
                                  href={`${path}${viewAll?.link || ''}`}
                                >
                                  <img
                                    alt={name}
                                    src={logoIcons[icon]}
                                    loading="lazy"
                                    className="size-20"
                                  />
                                </Tracked.ExternalLink>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </li>
  );
};

export default ClothingMenuItem;
